import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Model } from '@df/catalog/model';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ICmsClientDataModelService {
    readonly isOpen$ = new BehaviorSubject(false);

    constructor(
        private app: App,
        private requestService: RequestService
    ) {}

    /**
     * Preview api data in new type
     */
    previewApiData(model: Model) {
        const url = this.getApiLink(model);
        if (url) {
            window.open(url, '_blank')?.focus();
        }
    }

    flushApiCache(status: Status | undefined, type: string, ids: (number | string)[]) {
        return this.requestService.send(
            status,
            {
                path: `catalog/ci/${type}/${ids.join()}`
            },
            undefined,
            undefined,
            {
                api: 'node',
                method: 'GET'
            }
        );
    }

   

    private getApiLink(model: Model): string | undefined {
        return (model?.id && model.type && `${this.app.dfConfig.endpoint.nodeApi}${model.type}/${model.id}/verbosity/3`) || undefined;
    }
}
